import { Box, CircularProgress } from '@mui/material'

export const LoadingLayout = () => {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        height: '360px',
        gap: 2,
      }}
    >
      <CircularProgress color="primary" />
    </Box>
  )
}
